<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" /> 


    <div v-if="modoDefinirPessoa">        
        <div class="form-edit-page row-space">
            <div class="row">
                <div class="form-item">
                    <PessoaFrame v-model:objSelecionado="pessoaSelecionada"/>
                </div>  
                <button class="btn-confirm" @click="setDigitacao">Iniciar</button>
            </div>
        </div>
    </div>

 
    <div v-if="!modoDefinirPessoa">       
        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption">Nome Participante</label>
                <div class="field-label">{{ pessoaSelecionada?.nmpessoa }}</div>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Fone</label>
                <div class="field-label field-label-center">{{ pessoaSelecionada?.fone }}</div>
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption">Município</label>
                <div class="field-label">{{ pessoaSelecionada?.nmmunicipio }}{{ pessoaSelecionada?.uf ? ' / ' + pessoaSelecionada.uf : '' }}</div>
            </div>
        </div>


        <div class="form-edit-page row-space">
            <div class="row-start row-space">
                <div class="form-item-char20">
                    <TipoNotaSelect v-model:tipoSelecionado="tpNota" />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data Emissão</label>
                    <input type="date" v-model="edDfEmissao" />
                </div>
                
                <div class="form-item-char20">
                    <label class="label-caption">Valor</label>
                    <input v-model="edDfValor" v-decimal type="text" class="input-right" />
                </div>


                <div v-if="modoChaveAcesso" class="form-item">
                    <label class="label-caption">Chave</label>
                    <input type="text" class="input-center" v-model="edDfChave" maxlength="44" v-digits />
                </div>
                <template v-else> 
                    <div class="form-item-char20">
                        <label class="label-caption">Número</label>
                        <input type="text" class="input-right" v-model="edDfNumero" v-number maxlength="11" />
                    </div>

                    <div class="form-item">
                        <label class="label-caption">CPF/CNPJ Emissor</label>
                        <input type="text" class="input-center" v-model="edDocEmissor" maxlength="18" v-mask-cpf-cnpj />
                    </div>
                </template>
            </div>
            

            <div class="row-end">
                <button class="btn-confirm" @click="gravarNota">Gravar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </div>
    </div>

    <div v-if="lsNotas.length>0" class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th class="col-width-date">Data</th>
                    <th class="col-width-char10">Nro NF</th>
                    <th>Fornecedor</th>
                    <th class="col-width-char15">Valor</th>
                    <th class="col-width-char20">Situação</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsNotas" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" 
                    @click="setVisualizar(obj)">
                    <td class="center">{{ Funcoes.formatDateFromJson(obj.dtregistro) }}</td>
                    <td class="right">{{ Funcoes.formatInteger(obj.dfnumero) }}</td>
                    <td>{{ obj.nmfornecedor }}</td>
                    <td class="right">{{ Funcoes.formatDecimal(obj.dfvalor) }}</td>
                    <td>{{ obj.nmstatus }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script setup>
import { computed, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validacoes } from '@/funcoes/validacoes';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import PessoaFrame from '@/components/frames/PessoaFrame.vue';
import TipoNotaSelect from '@/selects/estaticos/TipoNotaSelect.vue';


const emit=defineEmits(['close', 'salvo']);


const edDfChave = ref(null);
const edDfEmissao = ref(null);
const edDfNumero = ref(null);
const edDfValor = ref(null);
const edDocEmissor = ref(null);
const msgAlerta = ref(false);
const isLoading = ref(false);
const lsNotas = ref([]);
const modoDefinirPessoa = ref(true);
const tpNota = ref(null);
const pessoaSelecionada = ref(null);

const modoChaveAcesso = computed(() => tpNota.value !== 'NS');


function cancelForm() {emit('close')}


async function gravarNota() {
    try {
        msgAlerta.value=null;
        Validacoes.validarId(pessoaSelecionada.value, "Informe o contribuinte");
        Validacoes.validarTexto(tpNota.value, "Informe o tipo do documento");
        Validacoes.validarData(edDfEmissao.value, -360);
        if (Funcoes.decimalFromString(edDfValor.value) <= 0) throw new Error("Informe valor correto do documento");
        if (modoChaveAcesso.value) Validacoes.validarChaveAcesso(edDfChave.value);
        if (!modoChaveAcesso.value && Funcoes.integerFromString(edDfNumero.value)<1) throw new Error("Informe corretamente o número do documento"); 
        if (!modoChaveAcesso.value) Validacoes.validarCNPJouCPF(edDocEmissor.value);
        isLoading.value=true;
        const nota = {
            id: 0,
            idmunicipio: globalStore.idmunicipio,
            idprograma: globalStore.idprograma,
            idpessoa: pessoaSelecionada.value.id,
            dfchave: (modoChaveAcesso.value) ? edDfChave.value : null,
            dfserie: (modoChaveAcesso.value) ? null : 999,
            dfnumero: (modoChaveAcesso.value) ? null : Funcoes.integerFromString(edDfNumero.value),
            dfdtemissao: edDfEmissao.value,
            dfvalor: Funcoes.decimalFromString(edDfValor.value),
            dfcpfcnpj_emissor: (modoChaveAcesso.value) ? null : edDocEmissor.value,
            tpnota: tpNota.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario};
        const response = await Api.genericPut('/cad/nota/add', nota);
        if (response.bolok===1){
            // CONSULTA NOTA PARA LISTA DAS INCLUSÕES
            const req = await Api.genericPost('/listas/notas', {
                idmunicipio: globalStore.idmunicipio,
                id: response.id});
            if (req) {
                lsNotas.value = [...lsNotas.value, ...(Array.isArray(req) ? req : [req])]
            }
            limparCampos();
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}            
}

function limparCampos(){
    edDfChave.value=null;
    edDfNumero.value=null;
    edDfValor.value=null;
    edDocEmissor.value=null;
}

function setDigitacao(){
    if (pessoaSelecionada.value){
        msgAlerta.value=null;
        modoDefinirPessoa.value=false;
    }else{
        msgAlerta.value='ATENÇÃO: Informe o participante';
    }
}
</script>